import { Button as AntButton, Modal, Table, TableColumnsType } from 'antd';
import { useTranslation } from 'react-i18next';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

interface iSmsGuideColumn {
  type: string;
  target: string;
  content: string;
}

const SmsGuideModal = (prop: IProps) => {

  const { t } = useTranslation();

  const getColumns = () => {
    let smsColumn: TableColumnsType<iSmsGuideColumn> = [];

    smsColumn = [
      {
        title: '구분',
        dataIndex: 'type',
        align: 'center',
        width: 100,
      },
      {
        title: '발송 대상',
        dataIndex: 'target',
        align: 'left',
        width: 280,
        render: value => <div style={{ whiteSpace: 'pre-line' }}>{value}</div>,
      },
      {
        title: '문자 내용',
        dataIndex: 'content',
        align: 'left',
        render: value => <div style={{ whiteSpace: 'pre-line' }}>{value}</div>,
      },
    ]
    return smsColumn;
  }

  const smsRows: Array<iSmsGuideColumn> = [
    {
      type: '기본',
      target: '사전 설문·사전 테스트를 완료했거나,\n사전 설문·사전 테스트 대상이 아닌 학생',
      content: `[CANB어학원 신규테스트 리마인드 알림]

○○○ 학생의 신규 테스트가 0000-00-00(요일) 00:00 에 진행됩니다.
10분 전까지 도착 부탁드립니다.

변동 사항이 있으시면 캠퍼스 전화 문의 부탁드립니다.
{캠퍼스명} 연락처 : {캠퍼스 전화번호}`,
    },
    {
      type: '사전 설문',
      target: '사전 설문 미완료 학생',
      content: `[CANB어학원 신규테스트 리마인드 알림]

○○○ 학생의 신규 테스트가 0000-00-00(요일) 00:00 에 진행됩니다.
10분 전까지 도착 부탁드립니다.

방문 전 아래 두 가지를 확인 부탁드립니다.
- 사전 설문(학부모님 ID)
- 사전 테스트(학생 ID)
미리 완료해 두시면 당일 테스트를 한결 여유롭게 진행하실 수 있습니다.
ID가 확인이 어려우신 경우 아래 번호로 문의 주시면 바로 안내해 드리겠습니다.

변동 사항이 있으시면 캠퍼스 전화 문의 부탁드립니다.
{캠퍼스명} 연락처 : {캠퍼스 전화번호}`,
    },
    {
      type: '사전 테스트',
      target: '사전 설문 완료 + 사전 테스트 미응시 학생',
      content: `[CANB어학원 신규테스트 리마인드 알림]

○○○ 학생의 신규 테스트가 0000-00-00(요일) 00:00 에 진행됩니다.
10분 전까지 도착 부탁드립니다.

방문 전 학생 ID로 사전 테스트 응시를 부탁드립니다.
미리 응시해 두시면 당일 테스트를 한결 여유롭게 진행하실 수 있습니다.
ID가 확인이 어려우신 경우 아래 번호로 문의 주시면 바로 안내해 드리겠습니다.

변동 사항이 있으시면 캠퍼스 전화 문의 부탁드립니다.
{캠퍼스명} 연락처 : {캠퍼스 전화번호}`,
    },
  ];

  return (
    <>
      <Modal
        title="입학시험 리마인드 문자 안내"
        onCancel={() => prop.setVisible(false)}
        open={prop.visible}
        width={900}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton key="cancel" className='btn-basic gray' onClick={() => prop.setVisible(false)}>
              {t('common.button.close')}
            </AntButton>
          </div>
        ]}
      >
        <p>시험 전날 20시에 입학시험 응시자(학생)의 보호자에게 리마인드 문자가 자동 발송됩니다.</p>
        <p>응시자의 사전 설문·사전 테스트 안내 여부에 따라 아래 3가지 중 하나가 발송됩니다.</p>
        <div className='comm-table__area mt-0'>
          <Table
            columns={getColumns()}
            dataSource={smsRows}
            pagination={false}
            rowKey="type"
          />
        </div>
      </Modal>
    </>
  );
}

export default SmsGuideModal;
